// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class JobNameMessage implements flatbuffers.IUnpackableObject<JobNameMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): JobNameMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsJobNameMessage(bb: flatbuffers.ByteBuffer, obj?: JobNameMessage): JobNameMessage {
    return (obj || new JobNameMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsJobNameMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: JobNameMessage,
  ): JobNameMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new JobNameMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  jobName(): string;
  jobName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  jobName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startJobNameMessage(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addJobName(builder: flatbuffers.Builder, jobNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, jobNameOffset, 0);
  }

  static endJobNameMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // job_name
    return offset;
  }

  static createJobNameMessage(
    builder: flatbuffers.Builder,
    jobNameOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    JobNameMessage.startJobNameMessage(builder);
    JobNameMessage.addJobName(builder, jobNameOffset);
    return JobNameMessage.endJobNameMessage(builder);
  }

  unpack(): JobNameMessageT {
    return new JobNameMessageT(this.jobName());
  }

  unpackTo(_o: JobNameMessageT): void {
    _o.jobName = this.jobName();
  }

  unpackFields(...fields: string[]): JobNameMessageT {
    const t = new JobNameMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("job_name")) {
      t.jobName = this.jobName();
    }
    return t;
  }
}

export class JobNameMessageT implements flatbuffers.IGeneratedObject {
  constructor(public jobName: string | Uint8Array | null = null) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.jobName === null || this.jobName === undefined) {
      throw new Error('Required field "job_name" is not set');
    }
    const jobName = this.jobName !== null ? builder.createString(this.jobName!) : 0;

    return JobNameMessage.createJobNameMessage(builder, jobName);
  }

  clone(): JobNameMessageT {
    const obj = new JobNameMessageT();
    obj.jobName = this.jobName;
    return obj;
  }

  equals(other: JobNameMessageT): boolean {
    if (this.jobName !== other.jobName) return false;
    return true;
  }
}

export function verifyJobNameMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "job_name");
  } finally {
    verifier.popDepth();
  }
}
